import axios from "axios";
import { omit } from "lodash";
import { put, takeEvery, takeLatest } from "redux-saga/effects";
import {
    createdProposedRegulationReceived,
    proposedLinkCreated,
    receivedDividedLink
} from "../../actions/regulation/CreateRegulation";
import { getSubRestrictions } from "../../actions/Filters";
import {
    createProposedChangeAction,
    CreateProposedLinkAction,
    CREATE_PROPOSED_CHANGE,
    CREATE_PROPOSED_LINK,
    GetDividedLinkAction,
    GET_DIVIDED_LINK,
    ProposedLinkCreatedAction,
    ReceivedDividedLinkAction
} from "../../actions/regulation/CreateRegulation/types";
import { showError } from "../../components/commonUtilities";
import { GeneratorYieldType } from "../../interfaces/ActionReducer/GetMethod/GetResponse";

function* createProposedLink(
    action: CreateProposedLinkAction
): Generator<
    Promise<ProposedLinkCreatedAction> | GeneratorYieldType<ProposedLinkCreatedAction["payload"]>,
    void,
    ProposedLinkCreatedAction["payload"]["proposedLinkCreatedData"]
> {
    try {
        const json = yield axios
            .post("api/proposed_link/", action.payload.proposedLinkToCreate)
            .then((response) => response.data);

        yield put(proposedLinkCreated({ proposedLinkCreatedData: json }));
    } catch (error) {
        showError(error);
    }
}

export function* createProposedLinkSaga() {
    yield takeEvery(CREATE_PROPOSED_LINK, createProposedLink);
}

function* getDividedLink(
    action: GetDividedLinkAction
): Generator<
    Promise<ReceivedDividedLinkAction> | GeneratorYieldType<ReceivedDividedLinkAction["payload"]>,
    void,
    any
> {
    try {
        let json = yield axios
            .get("api/alllinks/get_divided_link/", { params: omit(action.payload, "parentLinkId") })
            .then((response) => response.data);

        if (action.payload?.parentLinkId) {
            json = {
                ...json,
                parentLinkId: action.payload.parentLinkId
            };
        }
        if (action.payload?.proposed_link_id) {
            json = {
                ...json,
                proposed_link_id: action.payload.proposed_link_id
            };
        }
        yield put(
            receivedDividedLink({
                data: {
                    ...json,
                    id:
                        action.payload.link_id ||
                        action.payload?.parentLinkId ||
                        action.payload?.proposed_link_id
                }
            })
        );
    } catch (error) {
        showError(error);
    }
}

export function* getDividedLinkSaga() {
    yield takeLatest(GET_DIVIDED_LINK, getDividedLink);
}

function* createProposedChange(action: createProposedChangeAction) {
    try {
        yield axios
            .post("api/proposed_regulation/create_proposed_change/", action.payload.data)
            .then((response) => response.data);
        //to clear divided link data and custom layer
        if (action.payload.afterProcess) {
            action.payload.afterProcess();
        }
        yield put(receivedDividedLink({ data: null }));
        yield put(createdProposedRegulationReceived({ data: true }));
        //to load filters
        const params = {
            fields: "id,name,display_name,filter_section,color,dash_style,activity__id,activity__name,in_viewer,in_manager,priority,editable_parking_price,permit_type,display_priority",
            in_manager: true
        };
        yield put(getSubRestrictions({ params }));
    } catch (error) {
        yield put(createdProposedRegulationReceived({ data: true }));
        showError(error);
    }
}

export function* createProposedChangeSaga() {
    yield takeLatest(CREATE_PROPOSED_CHANGE, createProposedChange);
}
